import { api } from './client';
import type { NormativeDocument, NormativeCategory, Paginated } from '@/types';

export const normativeApi = {
  async list(filters: { category?: string; search?: string } = {}): Promise<NormativeDocument[]> {
    const { data } = await api.get<Paginated<NormativeDocument>>('/normative-documents/', { params: filters });
    return data.results ?? (data as unknown as NormativeDocument[]);
  },
  async create(payload: { code: string; title: string; category: NormativeCategory; url?: string; note?: string }, file?: File): Promise<NormativeDocument> {
    if (file) {
      const fd = new FormData();
      Object.entries(payload).forEach(([k, v]) => { if (v) fd.append(k, String(v)); });
      fd.append('file', file);
      const { data } = await api.post<NormativeDocument>('/normative-documents/', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      return data;
    }
    const { data } = await api.post<NormativeDocument>('/normative-documents/', payload);
    return data;
  },
  async remove(id: number): Promise<void> { await api.delete(`/normative-documents/${id}/`); },
  async counts(): Promise<Record<string, number>> { return (await api.get('/normative-documents/counts/')).data; },
};
